"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPrioritisationScore = exports.getPrioritisationScoreForStrategy = exports.getAveragePrioritisationScore = exports.getTopPrioritisationScore = exports.getPrioritisationScoreEntries = exports.parsePrioritisationScoreMap = void 0;
exports.parsePrioritisationScoreMap = function (value) {
    if (!value) {
        return {};
    }
    var parsedValue = value;
    if (typeof value === 'string') {
        try {
            parsedValue = JSON.parse(value);
        }
        catch (_a) {
            return {};
        }
    }
    if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) {
        return {};
    }
    var parsedRecord = parsedValue;
    var result = {};
    for (var _i = 0, _b = Object.entries(parsedRecord); _i < _b.length; _i++) {
        var _c = _b[_i], strategyId = _c[0], rawScore = _c[1];
        if (typeof rawScore === 'number' && Number.isFinite(rawScore)) {
            result[strategyId] = rawScore;
        }
    }
    return result;
};
exports.getPrioritisationScoreEntries = function (value) {
    return Object.entries(exports.parsePrioritisationScoreMap(value))
        .map(function (_a) {
        var strategyId = _a[0], score = _a[1];
        return ({ strategyId: strategyId, score: score });
    })
        .sort(function (left, right) { return left.strategyId.localeCompare(right.strategyId, undefined, { numeric: true }); });
};
exports.getTopPrioritisationScore = function (value) {
    var entries = exports.getPrioritisationScoreEntries(value);
    if (entries.length === 0) {
        return null;
    }
    return entries.reduce(function (highest, entry) {
        return entry.score > highest ? entry.score : highest;
    }, entries[0].score);
};
exports.getAveragePrioritisationScore = function (value) {
    var entries = exports.getPrioritisationScoreEntries(value);
    if (entries.length === 0) {
        return null;
    }
    var total = entries.reduce(function (sum, entry) { return sum + entry.score; }, 0);
    return total / entries.length;
};
exports.getPrioritisationScoreForStrategy = function (value, strategyId) {
    var scores = exports.parsePrioritisationScoreMap(value);
    return strategyId in scores
        ? scores[strategyId]
        : null;
};
exports.formatPrioritisationScore = function (score) {
    return score.toFixed(2);
};
